import AbstractManageable from './abstract-manageable';
import LocalAuthority     from './local-authority';

export default class Rest extends AbstractManageable {

	/**
     * @param {LocalAuthority} localAuthority
	 * @param {Boolean}        receipt
	 * @param {Number}         amount
     * @param {Number}         year
	 */
	constructor(
			localAuthority,
			receipt,
			amount,
			year,
			creator,
			createdAt,
			updater,
			updatedAt
            ) {
		super(creator, createdAt, updater, updatedAt);

		this.year           = year;
		this.amount         = amount;
		this.localAuthority = localAuthority;
		this.receipt        = receipt;
	}

	/**
	 * @returns {Rest}
	 */
	static createFromJson = (json) => {
		if (!json) return null;
		return new Rest(
			LocalAuthority.createFromJson(json.localAuthority),
            json.receipt,
            json.amount,
            json.year
		);
	}
}


// WEBPACK FOOTER //
// ./src/model/rest.js